export default "__VITE_ASSET__DgHkcCHB__"